import {
  getQueryWithParams,
  getQuery,
  postMutation,
} from "src/components/ApolloConnection/ApolloProviderComponent";
import {
  GET_APPOINTMENT_PRESCIRPTION,
  LIST_MEDICINES,
  LIST_PRESCRIPTION_TEMPLATES,
} from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";
import {
  ADD_PRESCRIPTION,
  ADD_PRESCRIPTION_TEMPLATE,
  ADD_EYE_PRESCRIPTION_GLASSES,
} from "src/components/graphql/GraphQLmutation";

export async function addPrescription(data) {
  try {
    const response = await postMutation(ADD_PRESCRIPTION, data);
    if (typeof response == "undefined") {
      throw new Error("error", response);
    } else {
      snackbar({
        message: "Added Prescription successfully.",
        color: "success",
      });
      if (response?.errors) {
        throw new Error("error", response);
      } else if (response?.data?.addPrescription?.data) {
        return response?.data?.addPrescription?.data;
      } else {
        throw new Error("error", response);
      }
    }
  } catch (e) {
    snackbar({
      message: "Some error occured. Try again",
      color: "danger",
    });
    console.error("Error at Adding Prescription: ", e);
    return null;
  }
}

export async function addEyePrescriptionGlasses(data) {
  try {
    const response = await postMutation(ADD_EYE_PRESCRIPTION_GLASSES, data);
    if (typeof response == "undefined") {
      throw new Error(
        "Some error occured at Adding Eype Glass Prescription. Try again"
      );
    } else {
      if (
        response?.data?.addEyePrescriptionGlasses.statusCode >= 200 &&
        response?.data?.addEyePrescriptionGlasses.statusCode < 300 &&
        response?.data?.addEyePrescriptionGlasses?.data
      ) {
        snackbar({
          message: "Added Eye Glass Prescription successfully.",
          color: "success",
        });
        return response?.data?.addEyePrescriptionGlasses?.data;
      } else {
        if (
          response?.data?.addEyePrescriptionGlasses.message &&
          !response?.data?.addEyePrescriptionGlasses.message.length > 150
        ) {
          throw new Error(response?.data?.addPrescriptionTemplate.message);
        } else {
          throw new Error(
            "Some error occured at Adding Eype Glass Prescription. Try again"
          );
        }
      }
    }
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at Adding Prescription Template: ", e);
    return null;
  }
}

export async function addPrescriptionTemplate(data) {
  try {
    const response = await postMutation(ADD_PRESCRIPTION_TEMPLATE, data);
    if (typeof response == "undefined") {
      throw new Error(
        "Some error occured at Adding Prescription Template. Try again"
      );
    } else {
      if (
        response?.data?.addDiagnosisPrescriptionTemplate.statusCode >= 200 &&
        response?.data?.addDiagnosisPrescriptionTemplate.statusCode < 300
      ) {
        snackbar({
          message: "Added Prescription Template successfully.",
          color: "success",
        });
      } else {
        if (response?.data?.addDiagnosisPrescriptionTemplate.message) {
          if (
            response?.data?.addDiagnosisPrescriptionTemplate.message.length >
            150
          ) {
            throw new Error(
              "Some error occured at Adding Prescription Template. Try again"
            );
          } else {
            throw new Error(
              response?.data?.addDiagnosisPrescriptionTemplate.message
            );
          }
        } else if (response?.data?.addDiagnosisPrescriptionTemplate?.data) {
          return response?.data?.addDiagnosisPrescriptionTemplate;
        } else {
          throw new Error(
            "Some error occured at Adding Prescription Template. Try again"
          );
        }
      }
    }
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at Adding Prescription Template: ", e);
    return {
      error: e.message,
    };
  }
}
export async function getPrescription(data) {
  try {
    const response = await getQueryWithParams(
      GET_APPOINTMENT_PRESCIRPTION,
      data
    );
    if (typeof response == "undefined") {
      throw new Error("error", response);
    } else {
      snackbar({
        message: "Prescription Fetched successfully.",
        color: "success",
      });
      if (response?.errors) {
        throw new Error("error", response);
      } else if (response?.data?.getAppointment?.data) {
        return response?.data?.getAppointment?.data;
      } else {
        throw new Error("error", response);
      }
    }
  } catch (e) {
    snackbar({
      message: "Some error occured. Try again",
      color: "danger",
    });
    console.error("Error at  Prescription: ", e);
    return null;
  }
}
export async function listMedicines(data) {
  try {
    const response = await getQueryWithParams(LIST_MEDICINES, data, true);
    if (typeof response == "undefined") {
      throw new Error("error", response);
    } else {
      if (response?.errors) {
        throw new Error("error", response);
      } else if (response?.data?.listMedicine?.data) {
        return response?.data?.listMedicine?.data;
      } else {
        throw new Error("error", response);
      }
    }
  } catch (e) {
    snackbar({
      message: "Some error occured. Try again",
      color: "danger",
    });
    console.error("Error at  list mediicne: ", e);
    return [];
  }
}
export async function listPrescriptionTemplates(search = "", filters = "") {
  try {
    let clinicId = sessionStorage.getItem("clinic_id");
    const response = await getQueryWithParams(
      LIST_PRESCRIPTION_TEMPLATES,
      {
        search,
        clinicId,
        filters,
      },
      true
    );
    if (typeof response == "undefined") {
      throw new Error("error", response);
    } else {
      if (response?.errors) {
        throw new Error("error", response);
      } else if (response?.data?.listDiagnosisPrescriptionTemplates?.data) {
        return response?.data?.listDiagnosisPrescriptionTemplates?.data;
      } else {
        throw new Error("error", response);
      }
    }
  } catch (e) {
    snackbar({
      message: "Some error occured. Try again",
      color: "danger",
    });
    console.error("Error at  list mediicne: ", e);
    return [];
  }
}
